import React, { Fragment } from "react";

export default (
  <>
    <path d="M21.75 0H2.25C1.0125 0 0 1.0125 0 2.25v19.5C0 22.9875 1.0125 24 2.25 24H12V13.5H9v-3h3V9c0-2.4795 2.0205-4.5 4.5-4.5h3v3h-3c-.825 0-1.5.675-1.5 1.5v1.5h4.5l-.75 3H15V24h6.75c1.2375 0 2.25-1.0125 2.25-2.25V2.25C24 1.0125 22.9875 0 21.75 0z" />
  </>
);
